'use strict';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Strider = function (_React$Component) {
  _inherits(Strider, _React$Component);

  function Strider(props) {
    _classCallCheck(this, Strider);

    var _this = _possibleConstructorReturn(this, (Strider.__proto__ || Object.getPrototypeOf(Strider)).call(this, props));

    _this.state = {
      activeIndex: props.activeIndex || 0,
      active: true,
      hiding: false
    };
    _this.children = _react2.default.Children.toArray(_this.props.children);
    return _this;
  }

  _createClass(Strider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.children = _react2.default.Children.toArray(this.props.children);
    }
  }, {
    key: 'hide',
    value: function hide(cb) {
      var _this2 = this;

      this.setState({
        hiding: true,
        active: false
      }, function () {
        setTimeout(function () {
          cb();
        }, _this2.props.transitionSpeed);
      });
    }
  }, {
    key: 'show',
    value: function show() {
      var _this3 = this;

      setTimeout(function () {
        _this3.setState({
          active: true
        });
      }, this.props.transitionSpeed);
    }
  }, {
    key: 'shouldStep',
    value: function shouldStep(index) {
      return index !== this.state.activeIndex;
    }
  }, {
    key: 'next',
    value: function next() {
      var _this4 = this;

      var curr = this.state.activeIndex;
      var nextIndex = this.clamp(++curr);

      if (this.shouldStep(nextIndex)) {
        this.hide(function () {
          _this4.setState(function (state) {
            return {
              activeIndex: nextIndex,
              hiding: false
            };
          }, function () {
            setTimeout(function () {
              _this4.show();
            }, 0);
          });
        });
      }
    }
  }, {
    key: 'prev',
    value: function prev() {
      var _this5 = this;

      var curr = this.state.activeIndex;
      var prevIndex = this.clamp(--curr);

      if (this.shouldStep(prevIndex)) {
        this.hide(function () {
          _this5.setState(function (state) {
            return {
              activeIndex: prevIndex,
              hiding: false
            };
          }, function () {
            _this5.show();
          });
        });
      }
    }
  }, {
    key: 'goTo',
    value: function goTo(index) {
      var _this6 = this;

      this.hide(function () {
        _this6.setState(function (state) {
          return {
            activeIndex: _this6.clamp(index),
            hiding: false
          };
        }, function () {
          _this6.show();
        });
      });
    }
  }, {
    key: 'clamp',
    value: function clamp(index) {
      return Math.min(Math.max(index, 0), this.children.length - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      var step = this.children[this.state.activeIndex];
      return _react2.default.cloneElement(step, _extends({}, step.props, this.state, {
        next: this.next.bind(this),
        prev: this.prev.bind(this),
        goTo: this.goTo.bind(this)
      }));
    }
  }]);

  return Strider;
}(_react2.default.Component);

function Step(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return children(props);
}

module.exports = {
  Strider: Strider,
  Step: Step
};